import api from '@/libs/axiosInstance';
import type { ApiResponse, RecommendationBatchDto } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

const fetchRecommendations = async (): Promise<RecommendationBatchDto> => {
  const { data } = await api.get<ApiResponse<RecommendationBatchDto>>('/dashboard/recommendations');
  if (!data.data) throw new Error('Empty recommendations response');
  return data.data;
};

export const useRecommendationsQuery = (brandId: string) => {
  return useQuery<RecommendationBatchDto, Error>({
    queryKey: ['recommendations', brandId],
    queryFn: fetchRecommendations,
    enabled: !!brandId,
    staleTime: FIVE_MINUTES_MS,
  });
};
